import React, { useEffect, useRef } from 'react';
import '../../../../vdisolutions/Stylesv/EndUserComputingSection.css';
import cloudBackupImg1 from '../../../../assets/services/VDISolutions/secure_reliable.png';

const DisasterSection = () => {
  const textRef = useRef(null);
  const imageRef = useRef(null);

  useEffect(() => {
    const elements = [textRef.current, imageRef.current];

    const options = { threshold: 0.1 };

    const callback = (entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('animate');
          observer.unobserve(entry.target);
        }
      });
    };

    const observer = new IntersectionObserver(callback, options);

    elements.forEach(el => {
      if (el) observer.observe(el);
    });

    return () => observer.disconnect();
  }, []);

  return (
    <section className="end-user-section white-bg">
      <div className="end-user-container">
        <div className="end-user-text" ref={textRef}>
          <h1>Secure, Fast & Cost-Effective Desktop as a Service (DaaS)</h1>
          <p>
            Synectiks provides enterprise‑grade Desktop as a Service (DaaS), enabling organizations to securely publish business‑critical applications and desktops through a fast, reliable virtual desktop platform. Powered by Inuvika and built on best‑in‑class virtualization technology, our DaaS solution offers multiple delivery options, high availability, scalability, and a feature‑rich user experience across devices, locations, and network conditions. 
          </p>
          <p>
            Employees stay securely connected to their work - anytime, anywhere, on any device. Our security controls and operational processes align with SOC 2 and HIPAA requirements. 
          </p>
        </div>
        <div className="end-user-image" ref={imageRef}>
          <img src={cloudBackupImg1} alt="Cloud Backup Illustration" />
        </div>
      </div>
    </section>
  );
};

export default DisasterSection;
